module.exports = __webpack_public_path__ + "img/eigenvalues_graph_energy_crossings.213108b3.svg";